import React from 'react'
import './GalleryFooter.css'
import monolideyes from '../pages/assets/gallery/monolideyes.jpg'
import creatives from '../pages/assets/gallery/creatives.jpg'
import run from '../pages/assets/gallery/run.jpg'
import mirror from '../pages/assets/gallery/mirror.jpg'
import wolf from '../pages/assets/gallery/wolf.jpg'
import back from '../pages/assets/gallery/back.jpg'
import nike from '../pages/assets/gallery/nike.jpg'

const GalleryFooter: React.FC = () => {
  const scrollContainerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (!scrollContainer) return

    let isScrolling = false

    const handleWheel = (evt: WheelEvent) => {
      evt.preventDefault()

      if (isScrolling) return

      const direction = Math.sign(evt.deltaY)
      if (direction === 0) return

      const items = Array.from(scrollContainer.children) as HTMLElement[]
      if (items.length === 0) return

      // Find the current centered item
      const containerCenter = scrollContainer.scrollLeft + scrollContainer.clientWidth / 2

      let closestItemIndex = 0
      let minDistance = Infinity

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2
        const distance = Math.abs(containerCenter - itemCenter)
        if (distance < minDistance) {
          minDistance = distance
          closestItemIndex = index
        }
      })

      // Determine target index
      let targetIndex = closestItemIndex + direction

      // Clamp target index
      targetIndex = Math.max(0, Math.min(targetIndex, items.length - 1))

      // If we are already at the target (e.g. at edges), do nothing
      if (targetIndex === closestItemIndex) return

      const targetItem = items[targetIndex]

      // Calculate scroll position to center the target item
      const scrollTarget = targetItem.offsetLeft - (scrollContainer.clientWidth / 2) + (targetItem.offsetWidth / 2)

      isScrolling = true
      scrollContainer.scrollTo({
        left: scrollTarget,
        behavior: 'smooth'
      })

      // Reset scrolling flag after animation (approximate duration)
      setTimeout(() => {
        isScrolling = false
      }, 500)
    }

    scrollContainer.addEventListener('wheel', handleWheel, { passive: false })

    return () => {
      scrollContainer.removeEventListener('wheel', handleWheel)
    }
  }, [])

  return (
    <footer className="gallery-footer" id="gallery">
      <div className="gallery-header">
        <h2 className="gallery-title">My Vibe</h2>
      </div>

      <div className="gallery-grid" ref={scrollContainerRef}>
        <div className="gallery-item">
          <img src={monolideyes} alt="Gallery 1" />
        </div>
        <div className="gallery-item">
          <img src={creatives} alt="Gallery 2" />
        </div>
        <div className="gallery-item">
          <img src={run} alt="Gallery 3" />
        </div>
        <div className="gallery-item">
          <img src={mirror} alt="Gallery 4" />
        </div>
        <div className="gallery-item">
          <img src={wolf} alt="Gallery 5" />
        </div>
        <div className="gallery-item">
          <img src={back} alt="Gallery 6" />
        </div>
        <div className="gallery-item">
          <img src={nike} alt="Gallery 7" />
        </div>
      </div>
    </footer>
  )
}

export default GalleryFooter